import React from 'react';
import { ErrorBoundary as ErrorBoundaryWrapper } from 'react-error-boundary';
import { isStaleChunkError } from '../stale-chunk/staleChunkError';
import { recoverFromStaleChunk } from '../stale-chunk/staleChunkRecovery';

type Props = {
  children: React.ReactNode;
};

export type CreateAppErrorBoundaryOptions = {
  appVersion: string;
};

function DefaultErrorFallback() {
  return (
    <h1>
      Something went wrong. Please refresh and try again or contact support if
      the problem persists.
    </h1>
  );
}

/**
 * Shared app error boundary that reloads out of a stale bundle once per app
 * version.
 */
export function createAppErrorBoundary({
  appVersion,
}: CreateAppErrorBoundaryOptions): React.FC<Props> {
  const ErrorBoundary: React.FC<Props> = ({ children }) => {
    const onError = (error: unknown, _info: React.ErrorInfo) => {
      if (isStaleChunkError(error)) {
        recoverFromStaleChunk({ appVersion });
      }
    };

    return (
      <ErrorBoundaryWrapper
        FallbackComponent={DefaultErrorFallback}
        onError={onError}
      >
        {children}
      </ErrorBoundaryWrapper>
    );
  };

  return ErrorBoundary;
}
